import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Header({ isScrolled }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogoClick = (e) => {
    e.preventDefault();
    const container = document.getElementById('photo-scroll');
    setIsMobileMenuOpen(false); 
    
    if (location.pathname === '/photography') {
      if (container) {
        container.style.scrollSnapType = 'none';
        container.scrollTo({ top: 0, behavior: 'smooth' });
        
        setTimeout(() => {
          container.style.scrollSnapType = window.innerWidth >= 768 ? 'y mandatory' : 'y proximity';
        }, 1000);
      }
    } else {
      navigate('/photography');
    }
  };

  return (
    <nav 
      // Nav ini adalah SATU KACA BESAR. Kalau isi di dalamnya memanjang, kacanya ikut memanjang.
      className={`fixed top-0 left-0 w-full z-50 bg-white/30 backdrop-blur-xl border-b border-butter-line/20 transition-all duration-700 ease-in-out ${
        isScrolled || isMobileMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}
    >
      {/* BAR ATAS (Logo & Toggle Menu) */}
      <div className="max-w-[1280px] mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between relative z-50">
        
        {/* KIRI: Brand Statement Morph */}
        <button 
          onClick={handleLogoClick}
          className="relative group overflow-hidden h-10 w-48 md:w-56 flex items-center text-left focus:outline-none"
        >
          <span className="absolute font-butter-serif text-[24px] md:text-[28px] text-butter-text transition-all duration-500 ease-out group-hover:opacity-0 group-hover:blur-md group-hover:-translate-y-2">
            buttersando.
          </span>
          <span className="absolute font-butter-sans text-[12px] md:text-[13px] tracking-[0.3em] uppercase opacity-0 blur-md translate-y-2 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:blur-0 group-hover:translate-y-0 text-butter-text font-medium">
            ivan sridana
          </span>
        </button>

        {/* KANAN: Nav Items (Desktop) */}
        <div className="hidden md:flex items-center gap-10 font-butter-sans text-[11px] lg:text-[12px] text-butter-text uppercase tracking-[0.2em]">
          <Link to="/photography/about" className="hover:text-butter-accent transition-all duration-300 relative group">
            about
            <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-butter-accent transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <a href="https://instagram.com/buttersando" target="_blank" rel="noopener noreferrer" className="hover:text-butter-accent transition-all duration-300 relative group">
            instagram
             <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-butter-accent transition-all duration-300 group-hover:w-full"></span>
          </a>
          <Link to="/" className="hover:text-butter-accent transition-all duration-300 relative group">
            main site
             <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-butter-accent transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link to="/photography/contact" className="hover:text-butter-accent transition-all duration-300 border border-butter-text/20 px-4 py-2 rounded-sm hover:border-butter-accent transition-all">
            contact
          </Link>
        </div>

        {/* Mobile: Toggle Menu Burger */}
        <div 
          className="md:hidden flex items-center gap-2 cursor-pointer group"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
            <div className="flex flex-col items-end relative w-6 h-[10px] justify-between">
                <span className={`h-[1px] bg-butter-text absolute left-0 transition-all duration-300 ${isMobileMenuOpen ? 'w-6 top-[4px] rotate-45' : 'w-4 top-0 group-hover:w-6'}`}></span>
                <span className={`h-[1px] bg-butter-text absolute left-0 transition-all duration-300 ${isMobileMenuOpen ? 'w-6 top-[4px] -rotate-45' : 'w-6 bottom-0'}`}></span>
            </div>
            <span className="font-butter-sans text-[10px] uppercase tracking-widest text-butter-muted w-[30px] text-right">
              {isMobileMenuOpen ? 'Close' : 'Menu'}
            </span>
        </div>
      </div>

      {/* DROPDOWN MENU (Tidak pakai kotak terpisah, melainkan memanjangkan Nav) */}
      <div 
        className={`md:hidden w-full flex flex-col items-center gap-8 overflow-hidden transition-all duration-500 ease-in-out ${
          isMobileMenuOpen ? 'max-h-[500px] opacity-100 pt-8 pb-12 border-t border-butter-line/20' : 'max-h-0 opacity-0 pt-0 pb-0 border-t border-transparent'
        }`}
      >
        <Link to="/photography/about" onClick={() => setIsMobileMenuOpen(false)} className="font-butter-sans text-[13px] text-butter-text uppercase tracking-[0.2em] hover:text-butter-accent">
          about
        </Link>
        <a href="https://instagram.com/buttersando" target="_blank" rel="noopener noreferrer" className="font-butter-sans text-[13px] text-butter-text uppercase tracking-[0.2em] hover:text-butter-accent">
          instagram
        </a>
        <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="font-butter-sans text-[13px] text-butter-text uppercase tracking-[0.2em] hover:text-butter-accent">
          visit main site
        </Link>
        <Link to="/photography/contact" onClick={() => setIsMobileMenuOpen(false)} className="font-butter-sans text-[13px] text-butter-text uppercase tracking-[0.2em] border border-butter-text/20 px-8 py-3 rounded-sm hover:border-butter-accent transition-all mt-2">
          contact
        </Link>
      </div>

    </nav>
  );
}